import React from "react";
import "primereact/resources/themes/lara-light-cyan/theme.css"; // Example theme
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons
import { Dropdown } from "primereact/dropdown";

type CustomDropdownProps<T> = {
  value: T | null;
  onChange: (value: T | null) => void;
  options: T[];
  optionLabel?: keyof T | string;
  placeholder?: string;

  /** Render UI for selected value */
  valueTemplate?: (option: T | null, props?: any) => React.ReactNode;

  /** Render UI for each item in the dropdown */
  itemTemplate?: (option: T) => React.ReactNode;

  filter?: boolean;
  filterDelay?: number;
  className?: string;
  style?: React.CSSProperties | undefined;
};

export function CustomDropdown<T extends object>({
  value,
  onChange,
  options,
  optionLabel = "",
  placeholder = "Select",
  valueTemplate,
  itemTemplate,
  filter = false,
  filterDelay = 300,
  className = "",
  style = {},
}: CustomDropdownProps<T>) {
  return (
    <Dropdown
      style={style}
      value={value}
      onChange={(e) => onChange(e.value)}
      options={options}
      optionLabel={optionLabel as string}
      placeholder={placeholder}
      filter={filter}
      filterDelay={filterDelay}
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className={className}
    />
  );
}
